import React from "react";
import { Button, Form, Image, Modal, Container, Row } from "react-bootstrap";
import { GroupFields } from "../../reusableComponent/formFields/groupFields";
import MilestoneTable from "./MilestoneTable";
import { sortBy, get } from "lodash";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import { options } from "./milestone.helper";
import MultipleMilestoneTable from "./MultipleMilestoneTable";
import HideShowMileStoneButtton from "../HideShowMilestoneButton";
import CompletedBucket from "./CompletedBucket";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getLocalstorage } from "../../../helper";
import { toast } from "react-toastify";
import EditImage from "../../../assets/Edit_icon.svg";
import { successToastStyle, errorToastStyle } from "../../../customToast";
import htmlToFormattedText from "html-to-formatted-text";
import MilestoneButton from "../MilestoneButton";

export default class Buckets extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showAlert: false,
      bucketDetailForModal: {},
      disableReason: "",
      editReasonBtnText: false,
      editReasonFieldText: false,
      showPhases: false,
      stateWiseData: []
    };
  }
  ZIndex = value => {
    this.props.ZIndex(value);
  };
  toggleChange = (id, _selectedBucketData) => {
    this.openConfirmationAlert();
    //this.props.onChange(!_selectedBucketData.disabled, "disabled", id);
    this.props.onChange(
      htmlToFormattedText(this.state.disableReason),
      "disableReason",
      id
    );
    this.setState({
      disableReason: ""
    });
  };

  disableToggle = id => {
    /*  this.setState({
      disableReason: ""
    }, () => {
      //this.props.onChange(false, "disabled", id);
      this.props.onChange("", "disableReason", id);
    })*/

    this.props.onChange("", "disableReason", id);
  };

  openConfirmationAlert = async bucketDetail => {
    const {
      bucketMilestoneCOS,
      openMilestoneEdit,
      projectId,
      bucketDisableIssueCheck
    } = this.props;
    let issueExists = true;
    const findBucket =
      !!bucketMilestoneCOS &&
      !!bucketDetail &&
      bucketMilestoneCOS.findIndex(bk => bk.bucketId === bucketDetail.id);
    if (openMilestoneEdit) {
      try {
        const response = await bucketDisableIssueCheck(
          undefined,
          projectId,
          bucketDetail.id
        );
        issueExists = get(response, "data", null);
        if (!issueExists) {
          toast.error(
            <p className="toast-text-alignment">Issue Already Exists</p>,
            errorToastStyle
          );
        }
      } catch (error) {
        console.log(error);
      }
    }
    if (issueExists) {
      if (
        !!bucketMilestoneCOS[findBucket] &&
        !bucketMilestoneCOS[findBucket].completed
      ) {
        this.setState(prevState => ({
          showAlert: !prevState.showAlert,
          bucketDetailForModal: bucketDetail
        }));
      } else {
        this.setState({
          showAlert: false
        });
      }
    }
  };

  onStatusChange = e => {
    const { onChange, bucketId } = this.props;
    const {
      dataset: { key },
      value
    } = e.target;
    onChange(value, "completeStatus", bucketId);
  };

  onDisableHandler = (value, id) => {
    const { onChange } = this.props;
    this.setState({
      disableReason: value.trim() === "" ? "" : value
    });
  };

  onMilestoneButtonClick = showPhaseOnBucketComplete => {
    this.setState({
      showPhases: !showPhaseOnBucketComplete
    });
  };

  onMilestoneUpdated = isMilstoneUpdated => {
    const { onClickOfUpdateButton } = this.props;
    onClickOfUpdateButton(isMilstoneUpdated);
  };

  onClickOfShowMilestone = showPhases => {
    this.setState({
      showPhases: !showPhases
    });
  };

  handleStateWiseData = (data, index) => {
    this.setState({ stateWiseData: data });
    this.props.handleStateWiseData(data, index);
  };

  updatedCall = (data, index) => {
    this.props.updatedCall(data, index);
  };

  render() {
    const {
      props: {
        onChange,
        milestoneData,
        milestoneDataCOS,
        bucketId,
        bucketMilestoneCOS,
        responsibleAuthority,
        milestoneTableDataCOS,
        createMilestoneAction,
        saveNewMilestoneAction,
        deleteNewMilestoneAction,
        _selectedBucketData,
        milestoneError,
        handleTableOrder,
        draftMilestoneAction,
        onBlur,
        isEdit,
        cabinetbucketId,
        openMilestoneEdit,
        projectDetailBucketMilestoneCOS,
        checkIssueBeforeDeletion,
        projectId,
        checkIssueBeforeDisable,
        projectMilestoneStatus,
        editMilestoneOriginalDate,
        userID,
        userInfo,
        projectPPList,
        cabinetmilestoneTableDataCOS,
        createdBy,
        isMilestoneTableValidated,
        isMilestoneEdit,
        showPhaseOnBucketComplete,
        onClickOfSaveAsDraft,
        locations,
        cabinetMilestone,
        sponsoredByCategory,
        isCabinetMilestoneMandatoryExempt,
        isCabinetMilestoneMandatoryEditExempt
      }
    } = this;
    const {
      showAlert,
      bucketDetailForModal,
      disableReason,
      showPhases
    } = this.state;

    let _disableReason =
      (_selectedBucketData && _selectedBucketData.id) ===
      (bucketDetailForModal && bucketDetailForModal.id)
        ? _selectedBucketData && _selectedBucketData.disableReason
        : "";

    const groupCategory = getLocalstorage("groupCategory");
    return (
      <>
        <Form.Group
          className={`field-checkbox project-awarded-by bucket-wrapper milestone-update-form`}
        >
          <div className="form-field">
            <div className={`form-field-data form-field-mobile`}>
              {milestoneData &&
                Array.isArray(milestoneData) &&
                sortBy(milestoneData, "bucket.id").map((item, idx) => {
                  let bucketDetails = item.bucket;
                  let firstBucketId = idx == 0 && item[Object.keys(item)[0]].id;
                  let selectedBucketDetails =
                    bucketMilestoneCOS &&
                    bucketMilestoneCOS.length &&
                    bucketMilestoneCOS.find(
                      item => item.bucketId === bucketDetails.id
                    );
                  return (
                    <React.Fragment>
                      {cabinetMilestone ? (
                        <Form.Check
                          data-test={"milestone-" + bucketDetails.id}
                          className={
                            "form-checkbox" +
                            (cabinetbucketId === bucketDetails.id
                              ? " checked"
                              : "") +
                            (!cabinetbucketId &&
                            firstBucketId === bucketDetails.id
                              ? " checked"
                              : "")
                          }
                          style={{
                            display:
                              bucketDetails.name == "Cabinet Milestone"
                                ? "none"
                                : null
                          }}
                        >
                          <Form.Check.Input type="radio" name="project" />
                          {(!!_selectedBucketData &&
                            cabinetbucketId === bucketDetails.id &&
                            _selectedBucketData.completed) ||
                          (!!selectedBucketDetails &&
                            selectedBucketDetails.completed) ? null : (
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 400 }}
                              //defaultShow={true}
                              overlay={
                                <Tooltip
                                  id={idx}
                                  className={`issues-actions-tooltip`}
                                >
                                  {!!selectedBucketDetails &&
                                  selectedBucketDetails.disabled
                                    ? "Enable "
                                    : "Disable "}
                                  {bucketDetails.name}
                                </Tooltip>
                              }
                            >
                              <div className="disable-btn">
                                <label
                                  className="switch"
                                  data-test="disable-button"
                                >
                                  <input
                                    data-test="disable-button"
                                    type="checkbox"
                                    checked={
                                      !(
                                        !!selectedBucketDetails &&
                                        selectedBucketDetails.disabled
                                      )
                                    }
                                    disabled={
                                      !!_selectedBucketData &&
                                      cabinetbucketId === bucketDetails.id &&
                                      _selectedBucketData.completed
                                    }
                                    onChange={() => {
                                      selectedBucketDetails &&
                                      selectedBucketDetails.disabled
                                        ? this.disableToggle(bucketDetails.id)
                                        : this.openConfirmationAlert(
                                            bucketDetails
                                          );
                                      this.setState({
                                        editReasonBtnText: false
                                      });
                                    }}
                                  />
                                  <span
                                    data-test={
                                      "disable-milestone-bucket-" +
                                      bucketDetails.id
                                    }
                                    className="slider round"
                                  />
                                </label>
                              </div>
                            </OverlayTrigger>
                          )}
                          <Form.Text
                            className={`form-checkbox-label`}
                            onClick={() => {
                              onChange(bucketDetails.id, "bucketId");
                              this.setState({
                                showPhases: false
                              });
                            }}
                          >
                            <div
                              className={`${
                                _selectedBucketData &&
                                !_selectedBucketData.disabled
                                  ? "checkbox-text disabled-bucket-name checkbox-text"
                                  : "checkbox-text"
                              }`}
                            >
                              <div className="checkbox-label">
                                {bucketDetails.name}
                              </div>
                            </div>
                          </Form.Text>
                        </Form.Check>
                      ) : (
                        <Form.Check
                          data-test={"milestone-" + bucketDetails.id}
                          className={
                            "form-checkbox" +
                            (bucketId === bucketDetails.id ? " checked" : "") +
                            (!bucketId && firstBucketId === bucketDetails.id
                              ? " checked"
                              : "")
                          }
                          style={{
                            display:
                              bucketDetails.name == "Cabinet Milestone"
                                ? "none"
                                : null
                          }}
                        >
                          <Form.Check.Input type="radio" name="project" />
                          {(!!_selectedBucketData &&
                            bucketId === bucketDetails.id &&
                            _selectedBucketData.completed) ||
                          (!!selectedBucketDetails &&
                            selectedBucketDetails.completed) ? null : (
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 400 }}
                              //defaultShow={true}
                              overlay={
                                <Tooltip
                                  id={idx}
                                  className={`issues-actions-tooltip`}
                                >
                                  {!!selectedBucketDetails &&
                                  selectedBucketDetails.disabled
                                    ? "Enable "
                                    : "Disable "}
                                  {bucketDetails.name}
                                </Tooltip>
                              }
                            >
                              <div className="disable-btn">
                                <label
                                  className="switch"
                                  data-test="disable-button"
                                >
                                  <input
                                    data-test="disable-button"
                                    type="checkbox"
                                    checked={
                                      !(
                                        !!selectedBucketDetails &&
                                        selectedBucketDetails.disabled
                                      )
                                    }
                                    disabled={
                                      !!_selectedBucketData &&
                                      bucketId === bucketDetails.id &&
                                      _selectedBucketData.completed
                                    }
                                    onChange={() => {
                                      selectedBucketDetails &&
                                      selectedBucketDetails.disabled
                                        ? this.disableToggle(bucketDetails.id)
                                        : this.openConfirmationAlert(
                                            bucketDetails
                                          );
                                      this.setState({
                                        editReasonBtnText: false
                                      });
                                    }}
                                  />
                                  <span
                                    data-test={
                                      "disable-milestone-bucket-" +
                                      bucketDetails.id
                                    }
                                    className="slider round"
                                  />
                                </label>
                              </div>
                            </OverlayTrigger>
                          )}
                          <Form.Text
                            className={`form-checkbox-label`}
                            onClick={() => {
                              onChange(bucketDetails.id, "bucketId");
                              this.setState({
                                showPhases: false
                              });
                            }}
                          >
                            <div
                              className={`${
                                _selectedBucketData &&
                                !_selectedBucketData.disabled
                                  ? "checkbox-text disabled-bucket-name checkbox-text"
                                  : "checkbox-text"
                              }`}
                            >
                              <div className="checkbox-label">
                                {bucketDetails.name}
                              </div>
                            </div>
                          </Form.Text>
                        </Form.Check>
                      )}
                    </React.Fragment>
                  );
                })}
            </div>
            {_selectedBucketData && !_selectedBucketData.disabled ? null : (
              <Container
                className="reason-field mb-4 rounded"
                style={{ display: cabinetbucketId ? "none" : null }}
              >
                <div className="project-stage pt-4">
                  Project Stage is Disabled
                  {milestoneData &&
                    Array.isArray(milestoneData) &&
                    sortBy(milestoneData, "bucket.id").map(item => {
                      let bucketDetails = item.bucket;
                      let selectedBucketDetails =
                        bucketMilestoneCOS &&
                        bucketMilestoneCOS.length &&
                        bucketMilestoneCOS.find(
                          item => item.bucketId === bucketDetails.id
                        );
                      return (
                        _selectedBucketData &&
                        _selectedBucketData.bucketId === bucketDetails.id && (
                          <>
                            <Row>
                              <span className="disable-reason ml-3">
                                Reason -
                              </span>
                              <div className="reason ml-1">
                                {selectedBucketDetails.disableReason}
                              </div>
                            </Row>
                            <Row
                              onClick={() => {
                                this.openConfirmationAlert(bucketDetails);
                                this.setState({
                                  editReasonBtnText: true,
                                  editReasonFieldText: true
                                });
                              }}
                            >
                              <Image
                                className="edit-reason-icon mt-4 ml-3"
                                src={EditImage}
                              />
                              <div className="edit-reason mt-4">
                                Edit Reason
                              </div>
                            </Row>
                          </>
                        )
                      );
                    })}
                </div>
              </Container>
            )}
          </div>
        </Form.Group>
        {_selectedBucketData && _selectedBucketData.disabled ? null : (
          <div
            className="radio-status-grp"
            style={{
              display:
                _selectedBucketData &&
                _selectedBucketData.bucketName == "Cabinet Milestone"
                  ? "none"
                  : null
            }}
          >
            <div className="radio">
              <label data-test="label-completed">
                <input
                  data-test="completed-radio-button"
                  type="radio"
                  value="completed"
                  checked={_selectedBucketData && _selectedBucketData.completed}
                  onChange={this.onStatusChange}
                />
                Completed
              </label>
            </div>
            <div className="radio">
              <label data-test="label-not-comleted">
                <input
                  data-test="not-completed-radio-button"
                  type="radio"
                  value="notCompleted"
                  checked={
                    _selectedBucketData && !_selectedBucketData.completed
                  }
                  onChange={this.onStatusChange}
                />
                Not Completed
              </label>
            </div>
          </div>
        )}
        {_selectedBucketData &&
        _selectedBucketData.disabled ? null : _selectedBucketData &&
          _selectedBucketData.completed ? (
          <React.Fragment>
            <CompletedBucket
              bucketId={bucketId}
              onChange={onChange}
              milestoneDataCOS={milestoneDataCOS}
              milestoneTableDataCOS={milestoneTableDataCOS}
              bucketMilestoneCOS={bucketMilestoneCOS}
              onBlur={onBlur}
              isMilestoneTableValidated={isMilestoneTableValidated}
              isProjectId={this.props.projectId}
            />
          </React.Fragment>
        ) : null}
        {this.props.projectId ? (
          <MilestoneButton
            isMilestoneEdit={isMilestoneEdit}
            _selectedBucketData={_selectedBucketData}
            onMilestoneButtonClick={this.onMilestoneButtonClick}
            onMilestoneUpdated={this.onMilestoneUpdated}
            projectMilestoneStatus={projectMilestoneStatus}
            projectDetailBucketMilestoneCOS={projectDetailBucketMilestoneCOS}
            onClickOfSaveAsDraft={onClickOfSaveAsDraft}
            idOfProject={this.props.projectId}
          />
        ) : (
          <div className="d-flex justify-content-end">
            {_selectedBucketData && _selectedBucketData.completed && (
              <HideShowMileStoneButtton
                onMilestoneButtonClick={this.onClickOfShowMilestone}
              />
            )}
          </div>
        )}

        {(_selectedBucketData &&
          _selectedBucketData.completed &&
          (showPhases || showPhaseOnBucketComplete)) ||
        (_selectedBucketData && !_selectedBucketData.completed) ||
        cabinetbucketId ? (
          <div
            className={`${
              showPhases && _selectedBucketData && _selectedBucketData.completed
                ? "multiple-milestone-table"
                : ""
            }`}
          >
            {cabinetMilestone ? (
              <MultipleMilestoneTable
                draftLocation={this.props.draftLocation}
                onStateWisePhaseChange={this.props.onStateWisePhaseChange}
                pageDetail={this.props.pageDetail}
                milestoneData={milestoneData}
                ZIndex={this.ZIndex}
                bucketId={cabinetbucketId}
                cabinetbucketId={cabinetbucketId}
                isEdit={isEdit}
                cabinetMilestone={cabinetMilestone}
                onChange={onChange}
                milestoneDataCOS={milestoneDataCOS}
                milestoneTableDataCOS={cabinetmilestoneTableDataCOS}
                responsibleAuthority={responsibleAuthority}
                sponsoredByCategory={sponsoredByCategory}
                isCabinetMilestoneMandatoryExempt={
                  isCabinetMilestoneMandatoryExempt
                }
                isCabinetMilestoneMandatoryEditExempt={
                  isCabinetMilestoneMandatoryEditExempt
                }
                openedFromComplete={
                  _selectedBucketData &&
                  _selectedBucketData.completed &&
                  groupCategory !== "PMG"
                }
                isBucketCompleted={
                  _selectedBucketData && _selectedBucketData.completed
                }
                displayButtonForComplete={
                  _selectedBucketData && _selectedBucketData.completed
                }
                isBucketDisabled={
                  _selectedBucketData && _selectedBucketData.disabled
                }
                _selectedBucketData={_selectedBucketData}
                bucketMilestoneCOS={bucketMilestoneCOS}
                createMilestoneAction={createMilestoneAction}
                saveNewMilestoneAction={saveNewMilestoneAction}
                deleteNewMilestoneAction={deleteNewMilestoneAction}
                milestoneError={milestoneError}
                handleTableOrder={handleTableOrder}
                draftMilestoneAction={draftMilestoneAction}
                openMilestoneEdit={openMilestoneEdit}
                groupCategory={groupCategory}
                projectDetailBucketMilestoneCOS={
                  projectDetailBucketMilestoneCOS
                }
                checkIssueBeforeDeletion={checkIssueBeforeDeletion}
                projectId={projectId}
                checkIssueBeforeDisable={checkIssueBeforeDisable}
                projectMilestoneStatus={projectMilestoneStatus}
                userID={userID}
                userInfo={userInfo}
                projectPPList={projectPPList}
                createdBy={createdBy}
                isMilestoneTableValidated={isMilestoneTableValidated}
                editMilestoneOriginalDate={editMilestoneOriginalDate}
                showPhases={showPhases}
                locations={locations}
                handleStateWiseData={this.handleStateWiseData}
                deleteStateWiseData={this.props.deleteStateWiseData}
                stateWiseData={this.props.stateWiseData}
                costDistributionData={this.props.costDistributionData}
                groupId={this.props.groupId}
                updatedCall={this.updatedCall}
              />
            ) : (
              <MultipleMilestoneTable
                draftLocation={this.props.draftLocation}
                onStateWisePhaseChange={this.props.onStateWisePhaseChange}
                pageDetail={this.props.pageDetail}
                milestoneData={milestoneData}
                bucketId={bucketId}
                cabinetMilestone={cabinetMilestone}
                onChange={onChange}
                milestoneDataCOS={milestoneDataCOS}
                isCabinetMilestoneMandatoryExempt={
                  isCabinetMilestoneMandatoryExempt
                }
                isCabinetMilestoneMandatoryEditExempt={
                  isCabinetMilestoneMandatoryEditExempt
                }
                sponsoredByCategory={sponsoredByCategory}
                ZIndex={this.ZIndex}
                milestoneTableDataCOS={milestoneTableDataCOS}
                responsibleAuthority={responsibleAuthority}
                openedFromComplete={
                  _selectedBucketData &&
                  _selectedBucketData.completed &&
                  groupCategory !== "PMG"
                }
                isBucketCompleted={
                  _selectedBucketData && _selectedBucketData.completed
                }
                displayButtonForComplete={
                  _selectedBucketData && _selectedBucketData.completed
                }
                isBucketDisabled={
                  _selectedBucketData && _selectedBucketData.disabled
                }
                _selectedBucketData={_selectedBucketData}
                bucketMilestoneCOS={bucketMilestoneCOS}
                createMilestoneAction={createMilestoneAction}
                saveNewMilestoneAction={saveNewMilestoneAction}
                deleteNewMilestoneAction={deleteNewMilestoneAction}
                milestoneError={milestoneError}
                handleTableOrder={handleTableOrder}
                draftMilestoneAction={draftMilestoneAction}
                openMilestoneEdit={openMilestoneEdit}
                groupCategory={groupCategory}
                projectDetailBucketMilestoneCOS={
                  projectDetailBucketMilestoneCOS
                }
                checkIssueBeforeDeletion={checkIssueBeforeDeletion}
                projectId={projectId}
                checkIssueBeforeDisable={checkIssueBeforeDisable}
                projectMilestoneStatus={projectMilestoneStatus}
                userID={userID}
                userInfo={userInfo}
                projectPPList={projectPPList}
                createdBy={createdBy}
                isMilestoneTableValidated={isMilestoneTableValidated}
                editMilestoneOriginalDate={editMilestoneOriginalDate}
                showPhases={showPhases}
                locations={locations}
                handleStateWiseData={this.handleStateWiseData}
                deleteStateWiseData={this.props.deleteStateWiseData}
                stateWiseData={this.props.stateWiseData}
                costDistributionData={this.props.costDistributionData}
                groupId={this.props.groupId}
                updatedCall={this.updatedCall}
              />
            )}
          </div>
        ) : null}
        <Modal
          show={showAlert}
          onHide={this.openConfirmationAlert}
          className="milestone-modal modal-padding-mod"
        >
          <Modal.Header closeButton>
            <Modal.Title
              data-test="label-disable-bucket-name"
              style={{ fontFamily: "mpb", fontSize: "23px" }}
            >
              Disable {bucketDetailForModal && bucketDetailForModal.name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="confirm">
              <textarea
                placeholder="Enter reason for disabling project stage"
                onChange={e =>
                  this.onDisableHandler(e.target.value, bucketDetailForModal.id)
                }
                data-test="textarea-for-disable-reason"
              >
                {_selectedBucketData !== undefined &&
                _selectedBucketData.disabled === true &&
                this.state.editReasonFieldText
                  ? _selectedBucketData.disableReason
                  : ""}
              </textarea>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() =>
                this.toggleChange(
                  bucketDetailForModal && bucketDetailForModal.id,
                  _selectedBucketData
                )
              }
              className={"add-reason-btn" + (!disableReason ? " disabled" : "")}
              data-test="disable-button"
            >
              {this.state.editReasonBtnText ? "Update" : "Disable"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
